import React from 'react'
import ForgetPassword from '../components/Login/ForgetPassword'

const ForgetPage = () => {
  return (
    <div>
      < ForgetPassword/>
    </div>
  )
}

export default ForgetPage
